<script setup lang="ts">
import type { BlogArticle } from '#shared/blog/types';

defineProps<{
  article: BlogArticle
}>();
</script>

<template>
  <article
    target="_blank"
    class="flex flex-col gap-xs justify-between border border-neutral-70 px-m py-xs rounded-xl bg-white relative isolate
    group first:row-span-2 first:bg-secondary-40 first:text-white"
  >
    <span
      class="text-xs"
      v-text="article.tag"
    />
    <div class="flex flex-col lg:gap-s first:gap-xs">
      <a :href="article.link">
        <IadTitle
          variant="small-semibold"
          :text="article.title"
          class="whitespace-pre-line break-words line-clamp-2 text-secondary-40 group-first:text-white"
          tag="p"
        />
      </a>
    </div>
    <ClientOnly>
      <a
        :href="article.link"
        class="absolute inset-0"
      />
    </ClientOnly>
  </article>
</template>
